import { Check } from "lucide-react";
import * as React from "react";

interface HeroSectionProps {
  title: string;
  highlightedText: string;
  imageSrc: string;
  description: React.ReactNode;
  subheading?: string; // New subheading prop
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  highlightedText,
  // imageSrc,
  // description,
  subheading,
}) => {
  return (
    <div className="rounded-none">
      <div className="flex gap-10 ml-5 max-md:mr-10 lg:ml-28 mt-32 items-center max-md:flex-col">
        {/* Left Section */}
        <div className="flex flex-col w-[30%] ml-20 max-md:ml-0 max-md:w-full">
          {/* Title */}
          <div className="self-stretch text-4xl md:text-6xl ml-5 mt-4 font-poppins tracking-normal leading-tight text-white max-md:mt-10 max-md:max-w-full max-md:text-3xl">
            <span className="text-white leading-tight">{highlightedText} </span>
            {title}
          </div>  

          {/* Subheading */}
          {subheading && (
            <div className="mt-6 text-3xl text-[#57c0af]  font-poppins font-semibold ml-5">
              {subheading}
            </div>
          )}

          {/* Description */}
          {/* <div className="mt-5 text-white font-poppins font-medium leading-6 text-base ml-5 text-left">
            {description}
          </div> */}
            {/* <div className="grid md:grid-cols-2 gap-16 items-center mt-8 md:w-[1300px]"> */}
            {/* List */}
            {/* <div className="order-2 md:order-1"> */}
      
                {/* <div className="space-y-4 w-full">
                     {[
                        "Wealth management goes beyond numbers to protecting and growing legacies",
                        "Focused on fulfilling unique financial aspirations",
                        "NUQI Prive is the dedicated asset management division",
                        "Exclusively serves Ultra-High Net Worth Individuals (UHNI)",
                        "Delivers bespoke services with excellence and discretion"
                     ].map((item, idx) => (
                        <div key={idx} className="group flex items-center gap-6 p-5 rounded-lg border border-white/5 bg-white/[0.02] hover:bg-white/[0.05] hover:border-[#57c0af]/30 transition-all duration-300 transform hover:-translate-x-[-10px]">
                            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#57c0af]/10 flex items-center justify-center text-[#57c0af] group-hover:bg-[#57c0af] group-hover:text-black transition-all duration-300 group-hover:scale-110 shadow-[0_0_10px_rgba(13,211,255,0)] group-hover:shadow-[0_0_15px_rgba(13,211,255,0.4)]">
                                <Check size={14} strokeWidth={3} />
                            </div>
                            <span className="text-gray-300 font-light text-lg group-hover:text-white transition-colors">{item}</span>
                        </div>
                     ))}
                </div> */}
            {/* </div> */}

            {/* Quote Card */}
            {/* <div className="order-1 md:order-2 relative">
                <div className="relative z-10 bg-[#0A0A0A] border border-white/10 p-12 md:p-16 rounded-sm shadow-2xl shadow-black/50 overflow-hidden group hover:border-white/20 transition-colors duration-500">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-[#57c0af]/5 rounded-full blur-[80px] group-hover:bg-[#57c0af]/10 transition-colors duration-700"></div>

                    <div className="absolute top-8 left-8 text-8xl text-white/5 font-serif leading-none opacity-50 group-hover:text-[#57c0af]/20 transition-colors duration-500">"</div>
                    <p className="text-2xl md:text-3xl font-light text-white leading-relaxed italic relative z-10">
                        Through education, access, and transparent technology, we've cultivated a safe space where financial growth is grounded in values — not just returns.
                    </p>
                    <div className="mt-10 flex items-center gap-5 relative z-10">
                        <img src="" alt="" />
                        <div>
                            <p className="text-white text-sm font-bold tracking-widest uppercase group-hover:text-[#57c0af] transition-colors">The Nuqi Team</p>
                            <p className="text-[#57c0af] text-xs uppercase tracking-wider mt-1 opacity-80 group-hover:opacity-100">Visionaries</p>
                        </div>
                    </div>
                </div> */}
                {/* Decoration */}
                {/* <div className="absolute top-6 -right-6 w-full h-full border border-white/5 z-0 rounded-sm group-hover:translate-x-2 group-hover:-translate-y-2 transition-transform duration-500"></div> */}
            {/* </div> */}
            {/* </div> */}
        </div>

        {/* Right Section */}
        {/* <div className="flex flex-col ml-5 w-[60%] max-md:ml-0 max-md:w-full">
          <img
            loading="lazy"
            src={imageSrc}
            alt="Nuqi Prive hero section"
            className="object-contain grow w-full rounded-3xl aspect-[1.41] max-md:mt-10 max-md:max-w-full"
          />
        </div> */}

         {/* List */}
            <div className="order-2 md:order-1">
      
                <div className="space-y-4 w-full">
                     {[
                        "Wealth management goes beyond numbers to protecting and growing legacies",
                        "Focused on fulfilling unique financial aspirations",
                        "NUQI Prive is the dedicated asset management division",
                        "Exclusively serves Ultra-High Net Worth Individuals (UHNI)",
                        "Delivers bespoke services with excellence and discretion"
                     ].map((item, idx) => (
                        <div key={idx} className="group flex items-center gap-6 p-5 rounded-lg border border-white/5 bg-white/[0.02] hover:bg-white/[0.05] hover:border-[#57c0af]/30 transition-all duration-300 transform hover:-translate-x-[-10px]">
                            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#57c0af]/10 flex items-center justify-center text-[#57c0af] group-hover:bg-[#57c0af] group-hover:text-black transition-all duration-300 group-hover:scale-110 shadow-[0_0_10px_rgba(13,211,255,0)] group-hover:shadow-[0_0_15px_rgba(13,211,255,0.4)]">
                                <Check size={14} strokeWidth={3} />
                            </div>
                            <span className="text-gray-300 font-light text-lg group-hover:text-white transition-colors">{item}</span>
                        </div>
                     ))}
                </div> 
            </div>


      </div>
    </div>

  );
};
// // HeroSection.tsx (no change needed if description is of type React.ReactNode)
// import { HeroSectionProps } from "@/types";
// import * as React from "react";

// export const HeroSection: React.FC<HeroSectionProps> = ({
//   title,
//   highlightedText,
//   imageSrc,
//   description,
// }) => {
//   return (
//     <div className="rounded-none">
//       <div className="flex gap-10 ml-5 lg:ml-28 mt-10 items-center max-md:flex-col">
//         {/* Left Section */}
//         <div className="flex flex-col w-[30%] ml-20 max-md:ml-0 max-md:w-full">
//           {/* Title */}
//           <div className="self-stretch text-3xl font-medium ml-5 mt-4 font-poppins tracking-normal leading-6 text-[#57c0af] max-md:mt-10 max-md:max-w-full max-md:text-3xl">
//             <span className="text-white">{highlightedText} </span>
//             {title}
//           </div>
//           {/* Description */}
//           <div className="mt-10 text-white font-poppins leading-6 text-sm ml-5">
//             {description}
//           </div>
//         </div>

//         {/* Right Section */}
//         <div className="flex flex-col ml-5 w-[60%] max-md:ml-0 max-md:w-full">
//           <img
//             loading="lazy"
//             src={imageSrc}
//             alt="x`hero section"
//             className="object-contain grow w-full rounded-3xl aspect-[1.41] max-md:mt-10 max-md:max-w-full"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };


// import { HeroSectionProps } from "@/types";
// import * as React from "react";

// export const HeroSection: React.FC<HeroSectionProps> = ({
//   title,
//   highlightedText,
//   imageSrc,
//   description,
// }) => {
//   return (
//     <div className="rounded-none">
//       <div className="flex gap-10 ml-5 lg:ml-28 mt-10 items-center max-md:flex-col">
//         {/* Left Section */}
//         <div className="flex flex-col w-[30%] ml-20 max-md:ml-0 max-md:w-full">
//           {/* Title */}
//           <div className="self-stretch text-3xl font-medium ml-5 mt-4 font-poppins tracking-normal leading-6 text-[#57c0af] max-md:mt-10 max-md:max-w-full max-md:text-3xl">
//             <span className="text-white">{highlightedText} </span>
//             {title}
//           </div>
//           {/* Description */}
//           <div className="mt-10 text-white font-poppins leading-6 text-sm ml-5">
//             {description}
//           </div>
//         </div>

//         {/* Right Section */}
//         <div className="flex flex-col ml-5 w-[60%] max-md:ml-0 max-md:w-full">
//           <img
//             loading="lazy"
//             src={imageSrc}
//             alt="Nuqi Prive hero section"
//             className="object-contain grow w-full rounded-3xl aspect-[1.41] max-md:mt-10 max-md:max-w-full"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

